import { clsx } from 'clsx'
import { memo } from 'react'

interface IProps {
	className?: string
	title?: string
	description?: string
}

const ZSuspenseError: React.FC<IProps> = ({ className, title, description }) => {
	return (
		<div
			className={clsx(
				'wrapper2 min-h-[25vh] pt-12 pb-16 w-full bg-red-500/50 border-t border-b border-red-500/20',
				'flex flex-col items-center justify-center rounded-3xl my-6 lg:my-12',
				className
			)}
			role='status'
			aria-live='polite'
			aria-label='Vyskytla sa chyba pri načítaní stránky.'
		>
			<div className='wrapper'>
				<h1 className='text-white text-3xl lg:text-4xl font-semibold mb-6'>
					{title || 'Vyskytla sa chyba pri načítaní stránky.'}
				</h1>
				{description && <p className='text-white text-sm mb-2'>{description}</p>}
				<p className='text-white text-base'>
					V prípade že problém pretrváva, kontaktujte prosím naše klientske centrum
					e-mailom na{' '}
					<a
						href={`mailto:recepcia@medante.sk`}
						className='font-semibold underline hover:opacity-90'
					>
						recepcia@medante.sk
					</a>
				</p>
			</div>
		</div>
	)
}

export default memo(ZSuspenseError)
